import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import {
  THERAPY_TYPE_CODE_OPTIONS,
  buildTherapyTypeTranslationKey,
} from '@/constants/appointmentOptions';
import { resolveAppointmentColorClasses } from '@/constants/appointmentColors';

export function TherapyTypeLegend() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 px-6 py-3 border-b border-zooborder">
      {THERAPY_TYPE_CODE_OPTIONS.map(function renderLegendItem(therapyTypeCode) {
        const colorClasses = resolveAppointmentColorClasses(therapyTypeCode);
        return (
          <span
            key={therapyTypeCode}
            className="flex items-center gap-1.5 text-[11px] text-zoomuted"
          >
            <span className={cn('w-2.5 h-2.5 rounded-full', colorClasses.accentDot)} />
            {t(buildTherapyTypeTranslationKey(therapyTypeCode))}
          </span>
        );
      })}
    </div>
  );
}
